import React from "react"
import { Badge } from "reactstrap"
import "./bd-offers.css"
function ActiveInactive(props) {
  let status = props.data.status ? 1 : 0
  return (
    <>
      {status ? (
        <Badge
          color="success"
          className="cursor-pointer"
          pill
          onClick={() => {
            props.callChangeOfferStatus(props.data.offer_id)
          }}
        >
          Active
        </Badge>
      ) : (
        <Badge
          className="cursor-pointer"
          color="danger"
          pill
          onClick={() => {
            props.callChangeOfferStatus(props.data.offer_id)
          }}
        >
          Inactive
        </Badge>
      )}
    </>
  )
}

export default ActiveInactive
